import React from "react";

import { makeStyles } from "@material-ui/core/styles";

import { getLocaleValue } from "../../../helpers/get-locale-value";
import { Box, Typography } from "@material-ui/core";

import { MdKeyboardArrowRight } from "@react-icons/all-files/md/MdKeyboardArrowRight";
import Navigation from "../../shared-components/navigation";

import { useSelector } from "react-redux";

const useStyles = makeStyles({
  categoryLinkWrapper: {
    "&:hover $icon": {
      background: "#F1872C",
    },
  },

  icon: {
    background: "#868686",
    borderRadius: "50%",
    color: "#fff",
    marginRight: 10,
    width: 25,
    height: 25,
    flexShrink: 0,
  },
  iconActive: {
    background: "#F1872C",
  },
});

const NewsCategoryListItemViewDesktop = ({
  locale,
  data,
  location,
  currentNewsCategory,
}) => {
  const { variants, id, slug } = data;
  const category = getLocaleValue(locale, variants);
  const newsCategory = currentNewsCategory
    ? getLocaleValue(locale, currentNewsCategory.variants)
    : null;

  const locales = useSelector(state => {
    return state.localeReducer.locales;
  }, []);

  const localeDisplayCode = locales.find(lang => lang.code == locale)
    .display_code;

  const classes = useStyles();

  const isActive =
    location.pathname === `/news/${slug}` ||
    location.pathname === `/${localeDisplayCode}/news/${slug}` ||
    (newsCategory && category.content == newsCategory.content);

  return (
    <Navigation to={`/news/${slug}`} className={classes.categoryLinkWrapper}>
      <Box
        display="flex"
        alignItems="center"
        p={1}
        className={`${isActive ? "text-active" : ""}`}
      >
        <MdKeyboardArrowRight
          className={`${classes.icon} ${isActive ? classes.iconActive : ""}`}
        />
        <Typography variant="h5">{category.content}</Typography>
      </Box>
    </Navigation>
  );
};
export default NewsCategoryListItemViewDesktop;
